<template>
  <div class="drawer drawer--right">
    <nav class="drawer-nav" ref="drawerRef">
      <div class="drawer-nav-close-btn drawer-toggle">
        <img src="~@/assets/images/icon-close-btn.png" width="19" height="33">
      </div>
      <ul>
          <li><router-link to="/#">TOP</router-link></li>
          <li><router-link to="/service">サービス詳細</router-link></li>
          <li><router-link to="/flow">ご利用の流れ</router-link></li>
          <li><router-link to="/shop">店舗情報</router-link></li>
          <li><router-link to="/faq">よくある質問</router-link></li>
          <li><router-link to="/inquiry">お問い合わせ</router-link></li>
          <li><a href="https://www.suzuki.co.jp/car/">スズキ四輪車TOP</a></li>
      </ul>
    </nav>

    <div class="sp-wrapper">

      <!-- header -->
      <header>
        <yonrin-header />

        <div :class="{ 'head-in': true, of: true, 'head-in-none': !showHeadIn, 'with-center-logo': !top }">
          <!-- <a href="https://www.suzuki.co.jp/car/"><img class="header-left-logo pc tab" src="~@/assets/images/logo.svg" alt=""></a> -->

          <a href="https://www.suzuki.co.jp/car/" class="mobi">
            <img class="header-left-logo" src="~@/assets/images/logo.svg" alt="">
          </a>

          <router-link to="/" class="center-logo pc tab" v-if="!top">
            <span class="img-banner">スズキ定額マイカー</span>
          </router-link>

          <div class="head-in-info right">

            <a class="menu-btn drawer-toggle">
              <span></span>
              <span></span>
              <span></span>
            </a>

            <ul class="kotei-head-info-btn-list right of pc tab" v-if="showHeadButton">
              <li>
                <router-link to="/car?area=宮城"><span>宮城</span>エリアで探す</router-link>
              </li>
              <li>
                <router-link to="/car?area=福岡"><span>福岡</span>エリアで探す</router-link>
              </li>
              <li>
                <router-link to="/car?area=埼玉"><span>埼玉</span>エリアで探す</router-link>
              </li>
              <li>
                <router-link to="/car?area=大阪"><span>大阪</span>エリアで探す</router-link>
              </li>
            </ul>

          </div>

        </div>

        <div :class="{ 'kotei-head': true, 'no-btn': !showHeadButton }">
          <yonrin-header />
          <div class="head-row of">

            <router-link to="/" class="center-logo">
              <span class="img-banner">スズキ定額マイカー</span>
            </router-link>

            <div class="kotei-head-info right">

              <a class="menu-btn drawer-toggle">
                <span></span>
                <span></span>
                <span></span>
              </a>

              <ul class="kotei-head-info-btn-list right of pc tab" v-if="showHeadButton">
                <li class="right">
                  <router-link to="/car?area=宮城"><span>宮城</span>エリアで探す</router-link>
                </li>
                <li class="right">
                  <router-link to="/car?area=福岡"><span>福岡</span>エリアで探す</router-link>
                </li>
                <li class="right">
                  <router-link to="/car?area=埼玉"><span>埼玉</span>エリアで探す</router-link>
                </li>
                <li class="right">
                  <router-link to="/car?area=大阪"><span>大阪</span>エリアで探す</router-link>
                </li>
              </ul>

            </div>

          </div>
        </div>

        <div class="header-logo" v-if="top">
          <router-link class="header-logo-link" to="/">
            <img src="~@/assets/images/logo-top.png" alt="">
          </router-link>
        </div>


      </header>
      <!-- /header -->

      <slot />

      <!-- footer -->
      <footer class="page">

        <!-- foot-in -->
        <div class="foot-in">
          <div class="wrapper">

            <!-- メルマガ登録フォーム -->
            <mail-magazine-form v-if="!hideMagazineForm" />
            <!-- /メルマガ登録フォーム -->

            <center>
              <router-link to="/" class="foot-in-logo-img">
                <img src="~@/assets/images/logo-new.png" width="649" height="90">
              </router-link>
            </center>

            <div class="pagetop pc tab"><img src="~@/assets/images/pagetop-img.png" width="71" height="70"></div>

          </div>
        </div>
        <!-- /foot-in -->

        <!-- foot-sp-menu-list -->
        <ul class="foot-sp-menu-list of mobi">
          <li class="li-1">
            <a href="https://www.suzuki.co.jp/dealer/Map2/getPref/buycar" target="_blank">
              <span class="foot-sp-menu-list-in">
                <span class="foot-sp-menu-list-in-img">
                  <img src="~@/assets/images-sp/icon01-02.png" width="62" height="46">
                </span>
                <span class="foot-sp-menu-list-in-title">販売店検索</span>
              </span>
            </a>
          </li>
          <li class="li-2">
            <a href="/car/purchase/democar/">
              <span class="foot-sp-menu-list-in">
                <span class="foot-sp-menu-list-in-img">
                  <img src="~@/assets/images-sp/icon02-02.png" width="60" height="46">
                </span>
                <span class="foot-sp-menu-list-in-title">展示車<br>試乗車検索</span>
              </span>
            </a>
          </li>
          <li class="li-3">
            <a href="/car/purchase/estimate/">
              <span class="foot-sp-menu-list-in">
                <span class="foot-sp-menu-list-in-img">
                  <img src="~@/assets/images-sp/icon03-02.png" width="62" height="46">
                </span>
                <span class="foot-sp-menu-list-in-title">オンライン<br>見積り</span>
              </span>
            </a>
          </li>
          <li class="li-4">
            <a href="https://krs.bz/suzuki/m?f=166">
              <span class="foot-sp-menu-list-in">
                <span class="foot-sp-menu-list-in-img">
                  <img src="~@/assets/images-sp/icon04-02.png" width="62" height="46">
                </span>
                <span class="foot-sp-menu-list-in-title">カタログ請求</span>
              </span>
            </a>
          </li>
          <li class="li-pagetop">
            <a></a>
          </li>
        </ul>
        <!-- /foot-sp-menu-list -->

        <!-- foot-main -->
        <div class="foot-main">
          <div class="wrapper">

            <div class="of">

              <!-- foot-main-menu-list -->
              <div class="foot-main-menu-list of">

                <ul>
                  <li><a href="https://www.suzuki.co.jp/car/">スズキ四輪車TOP</a></li>
                  <li><router-link to="/">スズキ定額マイカーTOP</router-link></li>
                </ul>

                <ul>
                  <li><router-link to="/car?area=埼玉">埼玉エリアで探す</router-link></li>
                  <li><router-link to="/car?area=大阪">大阪エリアで探す</router-link></li>
                  <li><router-link to="/car?area=宮城">宮城エリアで探す</router-link></li>
                  <li><router-link to="/car?area=福岡">福岡エリアで探す</router-link></li>
                </ul>

                <ul>
                  <li><router-link to="/service">サービス詳細</router-link></li>
                  <li><router-link to="/flow">ご利用の流れ</router-link></li>
                  <li><router-link to="/faq">よくある質問</router-link></li>
                </ul>

                <ul>
                  <li><router-link to="/terms/use">利用規約</router-link></li>
                  <li><router-link to="/terms/tokushouhou">特定商取引法に基づく表示</router-link></li>
                  <li><router-link to="/terms/privacy">個人情報に関する取扱い</router-link></li>
                </ul>

              </div>
              <!-- /foot-main-menu-list -->

            </div>
          </div>
        </div>
        <!-- /foot-main -->

        <!-- foot-main-2 -->
        <div class="foot-main-2">
          <div class="wrapper new of">

            <!-- ラインアップ・購入をお考えの方 -->
            <section class="sec-1">

              <!-- ラインアップ -->
              <div class="foot-main-2-new-in">
                <a href="/car/lineup/" class="foot-main-2-new-in-title">
                  ラインアップ
                </a>
                <ul>
                  <li><a href="/car/lineup/#lightLineup">乗用車/軽自動車</a></li>
                  <li><a href="/car/lineup/#welfareLineup">福祉車両</a></li>
                  <li><a href="/car/lineup/#commercialLineup">ビジネスカー/商用車</a></li>
                </ul>
              </div>
              <!-- /ラインアップ -->

              <!-- 購入をお考えの方 -->
              <div class="foot-main-2-new-in">
                <a  href="/car/buying/" class="foot-main-2-new-in-title">
                  購入をお考えの方
                </a>
                <div class="of">
                  <ul class="pc-left">
                    <li><a href="https://www.suzuki.co.jp/dealer/Map2/getPref/buycar" target="_blank">販売店検索</a></li>
                    <li><a href="/car/purchase/estimate/">オンライン見積り</a></li>
                    <li><a href="/car/purchase/democar/">展示車・試乗車検索</a></li>
                    <li><a href="https://krs.bz/suzuki/m?f=166" target="_blank">カタログ請求</a></li>
                    <li><a href="/accessory_car/" target="_blank">アクセサリー</a></li>
                    <li><a href="/ucar/" target="_blank">中古車検索</a></li>
                    <li><a href="/car/teigakumycar/" target="_blank">定額マイカー<br class="mobi">（サブスクリプションサービス）</a></li>
                  </ul>
                  <ul class="pc-left">
                    <li><a href="/car/information/9navi/">カーナビ</a></li>
                    <li><a href="/car/goods/">車中泊GOODS LINE UP</a></li>
                    <li><a href="/car/smile_car_life/">スマイルカーライフ</a></li>
                    <li><a href="https://www.suzuki-finance.co.jp/credit/" target="_blank">クレジットのご案内</a></li>
                  </ul>
                </div>
              </div>
              <!-- /購入をお考えの方 -->

            </section>
            <!-- /ラインアップ・購入をお考えの方 -->

            <!-- オーナーの方・スズキを楽しむ -->
            <section class="sec-2">

              <!-- オーナーの方 -->
              <div class="foot-main-2-new-in">
                <a href="/car/afterservice/" class="foot-main-2-new-in-title">
                  オーナーの方
                </a>
                <ul>
                  <li><a href="/car/afterservice/safetycheck/">車検・整備</a></li>
                  <li><a href="/car/owners_manual/index_2.html" target="_blank">オーナーズマニュアル</a></li>
                  <li><a href="/car/afterservice/rescuemanual/">レスキューマニュアル</a></li>
                  <li><a href="/car/carlife/">カーライフサポート</a></li>
                  <li><a href="https://www.suzuki.co.jp/dealer/Map2/getPref/buycar" target="_blank">販売店検索</a></li>
                  <li><a href="https://www.suzuki.co.jp/dealer/Contact/addresschange/maker/" target="_blank">転居のご案内</a></li>
                </ul>
              </div>
              <!-- /オーナーの方 -->

              <!-- スズキを楽しむ -->
              <div class="foot-main-2-new-in">
                <a href="/car/entertainment/" class="foot-main-2-new-in-title">
                  スズキを楽しむ
                </a>
                <ul>
                  <li><a href="/car/entertainment/motorshow/">イベント・モーターショー</a></li>
                  <li><a href="/about/museum/">スズキを知る</a></li>
                  <li><a href="/car/entertainment/tvcm/">テレビCM情報</a></li>
                </ul>
              </div>
              <!-- /スズキを楽しむ -->

            </section>
            <!-- /オーナーの方・スズキを楽しむ -->

            <!-- メールマガジン登録・公式SNS -->
            <section class="sec-3">

              <!-- メールマガジン登録 -->
              <div class="foot-main-2-new-in">
                <a href="https://krs.bz/suzuki/m?f=41" class="foot-main-2-new-in-title">
                  メールマガジン登録
                </a>
                <div class="foot-main-2-new-text">
                  メールマガジンにご登録いただくことで、スズキの最新情報や便利なサービスなどの情報をご提供させていただきます。
                </div>
                <a href="https://krs.bz/suzuki/m?f=41" class="foot-main-2-new-link-btn">
                  <span>登録・変更・停止申し込み</span>
                </a>
              </div>
              <!-- /メールマガジン登録 -->

              <!-- 公式SNS -->
              <div class="foot-main-2-new-in">
                <a href="" class="foot-main-2-new-in-title">
                  公式SNS
                </a>
                <ul class="foot-main-2-new-in-sns-list of">
                  <li><a href="https://www.facebook.com/suzukicojp/" target="_blank" rel="noopener noreferrer" class="foot-main-2-new-in-sns-list-img"><img src="~@/assets/images/icon-facebook.png" width="100" height="100"></a></li>
                  <li><a href="https://x.com/suzukicojp" target="_blank" rel="noopener noreferrer" class="foot-main-2-new-in-sns-list-img"><img src="~@/assets/images/icon-x.png" width="100" height="100"></a></li>
                  <li><a href="https://www.youtube.com/user/suzukicojp" target="_blank" rel="noopener noreferrer" class="foot-main-2-new-in-sns-list-img"><img src="~@/assets/images/icon-youtube.png" width="100" height="100"></a></li>
                  <li><a href="https://www.tiktok.com/@suzukicojp" target="_blank" rel="noopener noreferrer" class="foot-main-2-new-in-sns-list-img"><img src="~@/assets/images/icon-tiktok.png" width="100" height="100"></a></li>
                </ul>
                <a href="/car/socialmedia_policy/" class="foot-main-2-new-in-link">ソーシャルメディア利用規約</a>
              </div>
              <!-- /公式SNS -->

            </section>
            <!-- /メールマガジン登録・公式SNS -->

          </div>
        </div>
        <!-- /foot-main-2 -->

        <!-- foot-main-3 -->
        <div class="foot-main-3">
          <div class="wrapper of">

            <!-- foot-main-3-list -->
            <ul class="foot-main-3-list of">
              <li><a href="/sitemap/">サイトマップ</a></li>
              <li><a href="/foruse/">ご利用にあたって</a></li>
              <li><a href="/privacy_statement/">個人情報の取り扱いについて</a></li>
            </ul>
            <!-- /foot-main-3-list -->

            <!-- foot-main-3-copyright -->
            <div class="foot-main-3-copyright">
              © Suzuki Motor Corporation, 2022. All rights reserved.
            </div>
            <!-- /foot-main-3-copyright -->

          </div>
        </div>
        <!-- /foot-main-3 -->

      </footer>
      <!-- /footer -->

      <div class="kotei-foot-link mobi">
        <div class="kotei-foot-link-title sans">
          利用可能なクルマを探す
        </div>
        <ul>
          <li><router-link to="/car?area=埼玉">埼玉エリアで探す</router-link></li>
          <li><router-link to="/car?area=大阪">大阪エリアで探す</router-link></li>
        </ul>
        <ul>
          <li><router-link to="/car?area=宮城">宮城エリアで探す</router-link></li>
          <li><router-link to="/car?area=福岡">福岡エリアで探す</router-link></li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue';
import pageScript from '@/assets/page.js';
import globalScript from '@/global';

import MailMagazineForm from '@/components/MailMagazineForm.vue';
import YonrinHeader from '@/components/YonrinHeader.vue';

/**
 * Page コンポーネントから使用されます。
 */
export default defineComponent({
  components: {
    YonrinHeader,
    MailMagazineForm,
  },
  props: {
    title: String,
    showHeadIn: Boolean,
    showHeadButton: Boolean,
    hideMagazineForm: Boolean,
    top: Boolean,
  },
  setup (props) {
    const drawerRef = ref<HTMLElement>();
    watch(() => props.title, title => {
      if (title) {
        document.title = title;
      }
    }, { immediate: true });

    onMounted(async () => {
      await globalScript();
      pageScript();
    });

    return {
      drawerRef,
    };
  },
});
</script>
